import React, { useState } from 'react';
import './LoginSignup.css';

const LoginSignup = ({ handleBackToHome }) => {
  const [isLogin, setIsLogin] = useState(true);
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState('');

  const handleLoginSubmit = (e) => {
    e.preventDefault();
    setPopupMessage('Please contact Carmel Lahaina Utility Services administration to set up your account access.\n\nPhone: (903) 353-1539\nEmail: support@cluservicesco.com');
    setShowPopup(true);
  };

  const handleSignupSubmit = (e) => {
    e.preventDefault();
    setPopupMessage('Please contact Carmel Lahaina Utility Services to set up your account.\n\nPhone: (903) 353-1539\nEmail: support@cluservicesco.com\n\nWe will help you create your portal access and get you started with our services.');
    setShowPopup(true);
  };

  const closePopup = () => {
    setShowPopup(false);
    setPopupMessage('');
  };

  return (
    <section className="login-signup-section">
      <div className="container">
        <div className="login-back-button">
          <button className="btn btn-secondary" onClick={handleBackToHome}>
            ← Back to Home
          </button>
        </div>
        <div className="login-signup-container">
          <div className="login-signup-header">
            <h2>Carmel Lahaina Utility Services Portal</h2>
            <p>Access your account or create a new one</p>
          </div>

          <div className="login-signup-tabs">
            <button 
              className={`tab-button ${isLogin ? 'active' : ''}`}
              onClick={() => setIsLogin(true)}
            >
              Log In
            </button>
            <button 
              className={`tab-button ${!isLogin ? 'active' : ''}`}
              onClick={() => setIsLogin(false)}
            >
              Sign Up
            </button>
          </div>

                      <div className="login-signup-form">
                        {isLogin ? (
                          <div className="login-content">
                            <form onSubmit={handleLoginSubmit}>
                              <div className="form-group">
                                <label htmlFor="email">Email Address</label>
                                <input
                                  type="email"
                                  id="email"
                                  name="email"
                                  required
                                  placeholder="Enter your email"
                                />
                              </div>
                              <div className="form-group">
                                <label htmlFor="password">Password</label>
                                <input
                                  type="password"
                                  id="password"
                                  name="password"
                                  required
                                  placeholder="Enter your password"
                                />
                              </div>
                              <button type="submit" className="btn btn-primary btn-full">
                                Log In
                              </button>
                            </form>
                          </div>
                        ) : (
                          <div className="signup-content">
                            <div className="info-card">
                              <div className="info-icon">👥</div>
                              <h3>New Account Setup</h3>
                              <p>Contact CLU Services to set up your new account and get started with our utility and contracting services.</p>

                              <div className="contact-info">
                                <div className="contact-item">
                                  <strong>Phone:</strong> (903) 353-1539
                                </div>
                                <div className="contact-item">
                                  <strong>Email:</strong> support@cluservicesco.com
                                </div>
                              </div>

                              <button
                                className="btn btn-primary btn-full"
                                onClick={handleSignupSubmit}
                              >
                                Contact Carmel Lahaina Utility Services
                              </button>
                            </div>
                          </div>
                        )}

            <div className="login-signup-footer">
              {isLogin ? (
                <p>
                  Need to set up a new account? 
                  <button 
                    className="link-button" 
                    onClick={() => setIsLogin(false)}
                  >
                    Contact Us
                  </button>
                </p>
              ) : (
                <p>
                  Already have an account? 
                  <button 
                    className="link-button" 
                    onClick={() => setIsLogin(true)}
                  >
                    Access Portal
                  </button>
                </p>
              )}
            </div>
          </div>

          <div className="login-signup-info">
            <h3>Portal Features</h3>
            <ul>
              <li>View project status and updates</li>
              <li>Submit service requests</li>
              <li>Access invoices and documents</li>
              <li>Schedule maintenance appointments</li>
              <li>Contact our support team</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Popup Modal */}
      {showPopup && (
        <div className="popup-overlay" onClick={closePopup}>
          <div className="popup-content" onClick={(e) => e.stopPropagation()}>
            <div className="popup-header">
              <h3>Contact Carmel Lahaina Utility Services</h3>
              <button className="popup-close" onClick={closePopup}>×</button>
            </div>
            <div className="popup-body">
              <div className="popup-icon">📞</div>
              <p className="popup-message">{popupMessage}</p>
            </div>
            <div className="popup-footer">
              <button className="btn btn-primary" onClick={closePopup}>
                Got it
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default LoginSignup;